import { Loading } from '@myxplor/ui'
import moment from 'moment'
import React from 'react'
import ActiveFilter from '../../../../ui/active-filter'
import { recordActionsToDisplay, RecordListActions } from '../../../../ui/gov-actions'
import DisplayRecordList from '../../../../ui/record-display-list'
import { addCertificateEvidence } from '../actions/add-certificate-evidence'
import { cancelCertificate } from '../actions/cancel-certificate'
import { createCertificate } from '../actions/create-certificate'
import { createDetermination } from '../actions/create-determination'
import { childNoLongerAtRisk } from '../actions/mark-no-longer-at-risk'
import { stateTerritory } from '../actions/update-state-territory'
import { viewSubmission } from '../actions/view-submission'
import { copySubmission } from '../actions/copy-submission'
import { GovRecordBadges } from './badges'
import { okStatus } from './helper'
import RecordMessages from '../../../../ui/record-messages'

const displayHumanReadable = ({status, has_ended, end_date}) => {
  
  let display = status

  if(has_ended) {
    display = 'ENDED'
  } else if(okStatus(status)) {
    display = moment(end_date, 'YYYY-MM-DD').fromNow(true)
  }

  return display
}

const level1 = [
  {
    key: 'end_date',
    label: 'Date Ending'
  },
  {
    key: 'start_date',
    label: 'Date Starting'
  },

  {
    label: 'Time Left',
    fn: displayHumanReadable
  },
  {
    key: 'gov_id',
    label: 'Reference'
  },
]

const level2 = [
  {
    key: 'child_first_name',
    label: 'First Name'
  },
  {
    key: 'child_last_name',
    label: 'Last Name'
  },
  {
    key: 'child_crn',
    label: 'Child CRN'
  },
]

const TopContent = ({
  available_actions,
  child,
  regHolderId,
  refresh_accs_gov_enrolments
}) => {
  return (
    <RecordListActions
      labelText="ACCS Actions"
      options={[
        createCertificate({
          available_actions,
          child,
          regHolderId,
          refresh_accs_gov_enrolments
        }),
        createDetermination({
          available_actions,
          child,
          regHolderId,
          refresh_accs_gov_enrolments
        })
      ]}
    />
  )
}

const actionsForRecord = ({
  refresh_accs_gov_enrolments,
  regHolderId,
  child
}) => ({ record }) => {
  return [
    addCertificateEvidence({
      regHolderId,
      child,
      record,
      refresh_accs_gov_enrolments
    }),
    childNoLongerAtRisk({
      regHolderId,
      child,
      record,
      refresh_accs_gov_enrolments
    }),
    cancelCertificate({
      regHolderId,
      child,
      record,
      refresh_accs_gov_enrolments
    }),
    stateTerritory({
      regHolderId,
      child,
      record,
      refresh_accs_gov_enrolments
    }),
    viewSubmission({
      regHolderId,
      child,
      record
    }),
    copySubmission({
      regHolderId,
      child,
      record,
      refresh_accs_gov_enrolments
    })
  ]
}

const filterActiveRecords = ({status}) =>
  !(status === 'CANCELLED' || status === '')

const ACCSView = ({
  accs_gov_enrolments,
  refresh_accs_gov_enrolments,
  child,
  regHolderId,
}) => {
  const { data, loading, errors } = accs_gov_enrolments

  if (loading)
    return <Loading>Loading Certificates and Determinations</Loading>
  const certificates = data.certificates || []
  const determinations = data.determinations || []
  const records = [...determinations, ...certificates]

  if(errors === 'Child dob Not Found') {
    const message = `Cannot create ACCS as ${child.first_name} ${child.last_name}'s date of birth cannot be found. Please ensure date of birth is set correctly.`
    return <RecordMessages messages={[{message}]}  />
  }

  return (
    <ActiveFilter records={records} filterOn={filterActiveRecords}>
      <DisplayRecordList
        pending={(record) => record.status === 'PENDING'}
        {...{
          records: records,
          name: 'Additional Child Care Subsidy Application',
          topContent: (
            <TopContent
              refresh_accs_gov_enrolments={refresh_accs_gov_enrolments}
              child={child}
              {...data}
              regHolderId={regHolderId}
            />
          ),
          actionButtonsComponent: recordActionsToDisplay({
            actionsForRecord: actionsForRecord({
              refresh_accs_gov_enrolments: () =>
                refresh_accs_gov_enrolments(child.accs_path),
              regHolderId,
              child,
            }),
          }),
          level1: level1,
          showRaw: true,
          level2: level2,
          recordBadgesComponent: GovRecordBadges,
        }}
      />
    </ActiveFilter>
  )
}

export default ACCSView



// WEBPACK FOOTER //
// ./src/care-enrolments/details/accs-gov-enrolments/view/index.js